"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityActionPhrase = exports.deduplicateFollowingActivitiesByUser = exports.MOVIE_ACTIVITY_PRIORITY = void 0;
/**
 * Activity priority for a single movie, from highest to lowest.
 *
 * Rules:
 * - Once a user reviews → all other signals are superseded (review shows in carousel)
 * - Once a user rates → "watched" and "wants to watch" are redundant
 * - Once a user watches → "wants to watch" is redundant
 *
 * Callers should exclude REVIEWED entries from UI since reviews
 * already appear in the dedicated reviews carousel.
 */
exports.MOVIE_ACTIVITY_PRIORITY = {
    movie_reviewed: 4,
    movie_rated: 3,
    movie_watched: 2,
    marked_as_watched: 2,
    watchlist_add: 1,
    movie_added_to_list: 1,
};
/**
 * Given a list of UserActivity records for the same movie,
 * returns one record per user — the highest-priority activity only.
 * Users whose top activity is `movie_reviewed` are excluded because
 * their review already surfaces in the reviews carousel.
 */
function deduplicateFollowingActivitiesByUser(activities) {
    var _a, _b;
    const byUser = new Map();
    for (const activity of activities) {
        const priority = (_a = exports.MOVIE_ACTIVITY_PRIORITY[activity.type]) !== null && _a !== void 0 ? _a : 0;
        if (priority === 0)
            continue;
        const existing = byUser.get(activity.uid);
        const existingPriority = existing ? ((_b = exports.MOVIE_ACTIVITY_PRIORITY[existing.type]) !== null && _b !== void 0 ? _b : 0) : 0;
        if (priority > existingPriority) {
            byUser.set(activity.uid, activity);
        }
    }
    return Array.from(byUser.values()).filter((a) => a.type !== 'movie_reviewed');
}
exports.deduplicateFollowingActivitiesByUser = deduplicateFollowingActivitiesByUser;
/** Human-readable action phrase for a given activity type and optional rating.
 *
 * Note: rateMovie() stores activities as 'movie_watched' type with a rating field,
 * so we check for a rating on all watch-type activities to show the correct label.
 */
function activityActionPhrase(type, rating) {
    switch (type) {
        case 'movie_rated':
            return rating ? `rated ${rating}/5` : 'rated it';
        case 'movie_watched':
        case 'marked_as_watched':
            return rating ? `rated ${rating}/5` : 'marked as watched';
        case 'watchlist_add':
        case 'movie_added_to_list':
            return 'added to watchlist';
        default:
            return 'has activity';
    }
}
exports.activityActionPhrase = activityActionPhrase;
